'use client'

import { addDays } from 'date-fns'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { CLICK_ID_PARAMS } from '@/lib/constants'
import { isDevelopment } from '@/lib/general-helpers'

declare global {
	interface Window {
		OnetrustActiveGroups?: string
	}
}

// const PERFORMANCE_AND_TARGETING_COOKIES_ID = 'C0007'

export function ClickIdTracker() {
	const searchParams = useSearchParams()

	// biome-ignore lint/correctness/useExhaustiveDependencies: runs once to register OneTrust listeners; (TODO:  consent changes come via OneTrustGroupsUpdated - LCMS-973)
	useEffect(() => {
		function setClickIdCookies() {
			// TODO: enable consent mode once fallback for url capture exists in the app signup flow - LCMS-973
			// const activeGroups = (window.OnetrustActiveGroups ?? '').split(',')

			// if (!activeGroups.includes(PERFORMANCE_AND_TARGETING_COOKIES_ID)) return

			for (const param of CLICK_ID_PARAMS) {
				const value = searchParams.get(param)

				if (!value) continue

				const expiry = addDays(new Date(), 14).toUTCString()
				const domainAttr = isDevelopment() ? '' : '; domain=.lokalise.com'
				const cookie = `${param}=${encodeURIComponent(value)}${domainAttr}; expires=${expiry}; path=/; SameSite=Lax; Secure`

				try {
					// biome-ignore lint/suspicious/noDocumentCookie: required for click ID tracking cookie
					document.cookie = cookie
				} catch (error) {
					console.error('Failed to set cookie:', error)
				}
			}
		}

		// Run once in case OneTrust is already initialized,(TODO: then on consent updates - LCMS-973)
		setClickIdCookies()

		// TODO: enable consent mode once fallback for url capture exists in the app signup flow - LCMS-973
		// document.addEventListener('OneTrustGroupsUpdated', setClickIdCookies)
		// return () => document.removeEventListener('OneTrustGroupsUpdated', setClickIdCookies)
	}, [])

	return null
}
